/**
 * Palette used for project group (list) customization.
 *
 * Keeping the mapping in one place means the chip in `ProjectDetail`,
 * the row in `Sidebar` and the picker popover stay in sync. Each entry
 * exposes:
 *   • `key`   — short slug stored in Mongo (`lists.color`)
 *   • `label` — user-facing name (TR)
 *   • `hex`   — swatch shown in the picker
 *   • `chip`  — tailwind classes for the inactive chip pill
 *   • `chipActive` — tailwind classes for the active/selected chip pill
 *   • `sidebarDot` — tailwind class for the small colored dot in the sidebar
 */
export const LIST_PALETTE = [
  {
    key: "rose",
    label: "Gül",
    hex: "#fb7185",
    chip: "bg-rose-100 text-rose-800 hover:bg-rose-200",
    chipActive: "bg-rose-600 text-white",
    sidebarDot: "bg-rose-500",
  },
  {
    key: "orange",
    label: "Turuncu",
    hex: "#fb923c",
    chip: "bg-orange-100 text-orange-800 hover:bg-orange-200",
    chipActive: "bg-orange-600 text-white",
    sidebarDot: "bg-orange-500",
  },
  {
    key: "amber",
    label: "Amber",
    hex: "#f59e0b",
    chip: "bg-amber-100 text-amber-800 hover:bg-amber-200",
    chipActive: "bg-amber-600 text-white",
    sidebarDot: "bg-amber-500",
  },
  {
    key: "emerald",
    label: "Yeşil",
    hex: "#10b981",
    chip: "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
    chipActive: "bg-emerald-600 text-white",
    sidebarDot: "bg-emerald-500",
  },
  {
    key: "sky",
    label: "Gökyüzü",
    hex: "#0ea5e9",
    chip: "bg-sky-100 text-sky-800 hover:bg-sky-200",
    chipActive: "bg-sky-600 text-white",
    sidebarDot: "bg-sky-500",
  },
  {
    key: "indigo",
    label: "Indigo",
    hex: "#6366f1",
    chip: "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
    chipActive: "bg-indigo-600 text-white",
    sidebarDot: "bg-indigo-500",
  },
  {
    key: "violet",
    label: "Mor",
    hex: "#8b5cf6",
    chip: "bg-violet-100 text-violet-800 hover:bg-violet-200",
    chipActive: "bg-violet-600 text-white",
    sidebarDot: "bg-violet-500",
  },
  {
    key: "pink",
    label: "Pembe",
    hex: "#ec4899",
    chip: "bg-pink-100 text-pink-800 hover:bg-pink-200",
    chipActive: "bg-pink-600 text-white",
    sidebarDot: "bg-pink-500",
  },
];

/** Default (neutral) palette entry — used when a list has no color set. */
export const DEFAULT_LIST_PALETTE = {
  key: "",
  label: "Renksiz",
  hex: "#71717a",
  chip: "bg-zinc-100 text-zinc-700 hover:bg-zinc-200",
  chipActive: "bg-zinc-900 text-white",
  sidebarDot: "bg-zinc-300",
};

/**
 * Resolve a palette entry by key. Falls back to the neutral entry when the
 * value is empty / unknown so consumers can rely on non-null classes.
 */
export function getListPalette(key) {
  if (!key) return DEFAULT_LIST_PALETTE;
  return LIST_PALETTE.find((p) => p.key === key) || DEFAULT_LIST_PALETTE;
}
